module.exports = __webpack_public_path__ + "static/img/email.6378a5f8.svg";